import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

const ADMIN_DELIVERY_CITIES_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/delivery-cities`;

export const ADMIN_DELIVERY_CITIES_API_PATHS = {
  GET_DELIVERY_CITIES: `${ADMIN_DELIVERY_CITIES_API_ROOT}`,
  CREATE_DELIVERY_CITY: `${ADMIN_DELIVERY_CITIES_API_ROOT}`,
  GET_DELIVERY_DAYS: `${ADMIN_DELIVERY_CITIES_API_ROOT}/delivery-days`,
  GET_DELIVERY_CITY_BY_ID: (deliveryCityId: string) => `${ADMIN_DELIVERY_CITIES_API_ROOT}/${deliveryCityId}`,
  UPDATE_DELIVERY_CITY: (deliveryCityId: string) => `${ADMIN_DELIVERY_CITIES_API_ROOT}/${deliveryCityId}`,
  ARCHIVE_DELIVERY_CITY: (deliveryCityId: string) => `${ADMIN_DELIVERY_CITIES_API_ROOT}/${deliveryCityId}`,
  RESTORE_DELIVERY_CITY: (deliveryCityId: string) => `${ADMIN_DELIVERY_CITIES_API_ROOT}/${deliveryCityId}/restore`,
};
